import { Link } from 'react-router-dom';
import { Calendar, ArrowUpRight } from 'lucide-react';

export const EventFeedLink = ({ eventId, postId }) => {
  if (!/^[A-Za-z0-9_-]+$/.test(eventId || '')) return null;
  return <Link to={`/events/${eventId}`} data-testid={`feed-event-link-${postId}`} className="flex items-center gap-3 mt-3 py-3 border-y border-[var(--ps-border)] text-[var(--ps-primary)] hover:text-[var(--ps-text-primary)] transition-colors">
    <Calendar size={20} /><span className="flex-1 font-medium">View event</span><ArrowUpRight size={18} />
  </Link>;
};